/**
 * InertRow — display-only block that owns no cells and does not
 * subsume children. Covers structural chrome: block, group, header,
 * label, timeline-legend, sheet-footer.
 */

import type { InertDescriptor } from "../descriptor.ts";
import type { RowMetadata } from "../../stores/row-metadata-store.ts";
import type { RowLocalId } from "../../ids/row-local-id.ts";
import type { ModelSheet } from "../../sheet/rows-sheet.ts";
import { sheetOf, sheetStores } from "../../sheet/sheet-stores.ts";
import { ModelRow } from "../model-row.ts";

/**
 * A display-only row that owns no cells and subsumes no children: block, group, header, label,
 * timeline legend and sheet footer chrome.
 */
export class InertRow extends ModelRow {
  declare readonly descriptor: InertDescriptor;

  constructor(id: RowLocalId, descriptor: InertDescriptor, sheet: ModelSheet) {
    super(id, descriptor, sheet);
  }

  config(): RowMetadata {
    return sheetStores(sheetOf(this)).rowMetadata.get(this.id);
  }

  override toDebug(): Record<string, unknown> {
    return {
      ...super.toDebug(),
      inert: this.descriptor.kind,
    };
  }
}
